/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
  UserNotificationsInfoApiV1NotificationsSettingsGetHeaderParams,
  UserNotificationsInfoApiV1NotificationsSettingsGet422,
} from '../../types/UserNotificationsInfoApiV1NotificationsSettingsGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const userNotificationsInfoApiV1NotificationsSettingsGetQueryKey = () => [{ url: '/api/v1/notifications_settings' }] as const

export type UserNotificationsInfoApiV1NotificationsSettingsGetQueryKey = ReturnType<typeof userNotificationsInfoApiV1NotificationsSettingsGetQueryKey>

/**
 * @summary User Notifications Info
 * {@link /api/v1/notifications_settings}
 */
export async function userNotificationsInfoApiV1NotificationsSettingsGet(
  headers?: UserNotificationsInfoApiV1NotificationsSettingsGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
    ResponseErrorConfig<UserNotificationsInfoApiV1NotificationsSettingsGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/notifications_settings`, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function userNotificationsInfoApiV1NotificationsSettingsGetQueryOptions(
  headers?: UserNotificationsInfoApiV1NotificationsSettingsGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = userNotificationsInfoApiV1NotificationsSettingsGetQueryKey()
  return queryOptions<
    UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
    ResponseErrorConfig<UserNotificationsInfoApiV1NotificationsSettingsGet422>,
    UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return userNotificationsInfoApiV1NotificationsSettingsGet(headers, config)
    },
  })
}

/**
 * @summary User Notifications Info
 * {@link /api/v1/notifications_settings}
 */
export function useUserNotificationsInfoApiV1NotificationsSettingsGet<
  TData = UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
  TQueryData = UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
  TQueryKey extends QueryKey = UserNotificationsInfoApiV1NotificationsSettingsGetQueryKey,
>(
  headers?: UserNotificationsInfoApiV1NotificationsSettingsGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        UserNotificationsInfoApiV1NotificationsSettingsGetQueryResponse,
        ResponseErrorConfig<UserNotificationsInfoApiV1NotificationsSettingsGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? userNotificationsInfoApiV1NotificationsSettingsGetQueryKey()

  const query = useQuery(
    {
      ...userNotificationsInfoApiV1NotificationsSettingsGetQueryOptions(headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<UserNotificationsInfoApiV1NotificationsSettingsGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}